import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../store/store';
import PlanningModule from './PlanningModule';
import PrealableSection from './PrealableSection';
import SubscriptionBanner from './SubscriptionBanner';

function ParametragePlanningTab() {
  const company = useSelector((state: RootState) => state.auth.company);
  const jwt = useSelector((state: RootState) => state.auth.token);

  return (
    <div className="flex flex-col gap-8">
      <div>
        <h2 className="mb-5 text-xl font-bold text-slate-800">
          Validez votre planning stratégique des 12 prochains mois
          <span className="ml-1 text-base font-normal text-gray-500">(dates et responsable de chaque action)</span>
        </h2>
        <PlanningModule />
      </div>

      <PrealableSection />

      <SubscriptionBanner company={company} jwt={jwt} />
    </div>
  );
}

export default ParametragePlanningTab;
